import React, { FC, useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button, ButtonGroup } from 'components/atoms/button';
import { OzoneDrawer as Drawer } from 'components/atoms/drawer';

const StyledButtonGroup = styled(ButtonGroup)`
  width: 100%;
`;

interface Props {
  title: string | React.ReactElement;
  onClose: VoidFunction;
  onSave: VoidFunction;
  isSubmitting: boolean;
  form: React.ReactElement;
}

export const RolesDrawer: FC<Props> = ({
  title,
  onClose,
  onSave,
  isSubmitting,
  form,
}) => {
  const [visible, setVisible] = useState(false);

  const onVisibleChange = useCallback(
    (_visible) => {
      if (!_visible) {
        onClose();
      }
    },
    [onClose],
  );

  const hide = useCallback(() => {
    setVisible(false);
  }, []);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <Drawer
      title={title}
      afterVisibleChange={onVisibleChange}
      onClose={hide}
      visible={visible}
      placement="right"
      width={360}
      destroyOnClose
      footer={
        <StyledButtonGroup>
          <Button onClick={hide}>
            <FormattedMessage id="cancel" />
          </Button>
          <Button loading={isSubmitting} type="primary" onClick={onSave}>
            <FormattedMessage id="save" />
          </Button>
        </StyledButtonGroup>
      }
    >
      {form}
    </Drawer>
  );
};
